import React from 'react';
import uuidv4 from "uuid/v4";
import ReactTooltip from "react-tooltip";

const Icon = (props) => {
    const tooltipId = uuidv4();
    return (
        <div className="icon" data-for={tooltipId} data-tip={props.tooltip}>
            <img src={props.image}/>
            {props.children}
            <ReactTooltip afterShow={function() {
                document.getElementById(tooltipId).classList.add('bounceIn');
            }} id={tooltipId} effect="solid" html={true}/>
        </div>
    )
};

export default Icon;
